import './ImageSlider.css';

const ImageSlider = ({ imgPath = "/references/", images = [], grayscale = false }) => {
    return (
        <div className="image-slider-container overflow-hidden py-4">
            <div className="image-slider-track d-flex no-interaction">
                {images.concat(images).concat(images).map((image, i) => (
                    <div
                        className={`image-slide mx-4 ${grayscale ? 'slider-img-grayscale' : ''}`}
                        key={image.imgSrc + i}
                    >
                        <img
                            src={`${imgPath}${image.imgSrc}`}
                            alt={image.alt || `Logo ${i}`}
                            className="slider-img"
                            loading="lazy"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageSlider;
